export default __webpack_public_path__ + "/assets/home-news-01-hover.png";